// src/i18n/LanguageContext.jsx

import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "./translations";

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState("ru");

  // Load language from localStorage or detect from browser
  useEffect(() => {
    const savedLanguage = localStorage.getItem("tcm-language");
    if (savedLanguage && (savedLanguage === "ru" || savedLanguage === "en")) {
      setLanguageState(savedLanguage);
    } else {
      // Auto-detect from browser language
      const browserLang = navigator.language || navigator.userLanguage || "";
      const detectedLang = browserLang.startsWith("en") ? "en" : "ru";
      setLanguageState(detectedLang);
      localStorage.setItem("tcm-language", detectedLang);
    }
  }, []);

  const setLanguage = (newLang) => {
    setLanguageState(newLang);
    localStorage.setItem("tcm-language", newLang);
    // Update HTML lang attribute
    document.documentElement.lang = newLang === "ru" ? "ru" : "en";
  };

  const t = (key) => {
    const keys = key.split(".");
    let value = translations[language];
    for (const k of keys) {
      if (value && value[k] !== undefined) {
        value = value[k];
      } else {
        return key; // Return key if not found
      }
    }
    return value;
  };

  const value = {
    language,
    setLanguage,
    t,
    isRu: language === "ru",
    isEn: language === "en"
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
